/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_NoneInputs */

const en_history_none = /** @type {(inputs: History_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not logged yet.`)
};

const de_history_none = /** @type {(inputs: History_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht eingetragen.`)
};

/**
* | output |
* | --- |
* | "Not logged yet." |
*
* @param {History_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_none = /** @type {((inputs?: History_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_none(inputs)
	return en_history_none(inputs)
});